import { httpService } from "./httpService";

export const manageStorageService = {
    async getStorageData(userId: number) {
        try {
            const response = await httpService.getRequest<any>(`users/${userId}/storage`);
            const storageData = response.data;
            return storageData;
        } catch (error) {
            console.error("Error fetching storage data:", error);
        }
    },
};